import { TApplicationState } from '../../types/redux';

export function getUserRole(state: TApplicationState) {
  return state.userRole;
}
